import { IImportModel } from '../importer/model';

export const ancillaryActivitiesRatesImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryActivitiesRatesImport as IImportModel;
